import Container from "react-bootstrap/Container";
import RetailLeadForm from "../../calculators/retailLeadForm";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function Nyugdijmegtakaritas() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">NYUGDÍJMEGTAKARÍTÁS • ADÓJÓVÁÍRÁS</span>

        <h1 className="title">
          Nyugdíjmegtakarítás <br />
          <span style={{ color: "#c7d2fe" }}>állami adójóváírással</span>
        </h1>

        <p className="subtitle">
          Önkéntes nyugdíjpénztári tagsággal vagy Nyugdíj-előtakarékossági
          Számlával (NYESZ) hosszú távon egészítheted ki a leendő állami
          nyugdíjad, miközben a befizetéseid után adójóváírást is igényelhetsz.
          <br />
          <span className="fw-bold">
            Nézd meg, melyik konstrukció illik hozzád, és kérj díjmentes
            tanácsadást!
          </span>
        </p>

        <div className="cta">
          <Button href="#tudnivalok" className="btn btn-primary">
            Hogyan működik?
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Tanácsadást kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">Akár 20%</div>
                <div className="muted">Adójóváírás a befizetések után</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Hosszú táv</div>
                <div className="muted">
                  Nyugdíjkorhatárig tartó megtakarítás
                </div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Rugalmas</div>
                <div className="muted">Havi vagy eseti befizetés is lehet</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="tudnivalok" className="section">
          <h2 className="h2">Melyik nyugdíjmegtakarítás illik hozzád?</h2>
          <p className="lead">
            A két leggyakoribb konstrukció az önkéntes nyugdíjpénztár és a
            Nyugdíj-előtakarékossági Számla (NYESZ) — mindkettő a befizetések
            után járó adójóváíráson keresztül teszi kedvezőbbé a hosszú távú
            megtakarítást.
          </p>

          <Row className="g-3 mt-2">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Önkéntes nyugdíjpénztár</h3>
                <p className="small">
                  Közösségi alapon működő, választható portfóliós befektetés; a
                  munkáltató is hozzájárulhat a befizetésekhez, ami tovább
                  növelheti a felhalmozott összeget.
                </p>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="card h-100">
                <h3>NYESZ számla</h3>
                <p className="small">
                  Banki vagy befektetési szolgáltatónál vezetett egyéni számla,
                  amelyen belül magad választhatod meg a befektetési eszközöket
                  (pl. állampapír, befektetési alap).
                </p>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2">Így indíthatod el a megtakarítást</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Egyeztetés</p>
                <p className="small">
                  Elmondod a céljaid és a jelenlegi helyzeted
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Konstrukció kiválasztása</p>
                <p className="small">
                  Javaslatot kapsz a hozzád illő megtakarítási formára
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Számlanyitás</p>
                <p className="small">
                  A kiválasztott szolgáltatónál elindítjuk az igénylést
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Rendszeres befizetés</p>
                <p className="small">
                  Havi vagy eseti befizetésekkel építed a megtakarításod
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen díjmentes tanácsadást!</h2>
          <p className="lead small">
            Add meg az adataid, és segítünk kiválasztani a számodra legkedvezőbb
            nyugdíjmegtakarítási formát.
          </p>
          <Row>
            <Col md={4}>
              <RetailLeadForm leadType="Pension" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes tanácsadás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több szolgáltató összehasonlítva</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Segítség a számlanyitásban</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Bankfüggetlen ajánlások</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mi az a nyugdíj-adójóváírás?",
                    answer:
                      "Az önkéntes nyugdíjpénztári és NYESZ-befizetések után az állam adójóváírást ad, amelyet a befizető visszaigényelhet, és a jóváhagyott összeg is a megtakarítási számlán gyarapítja a tőkét. A pontos mértéket és felső korlátot mindig az aktuális jogszabályok határozzák meg.",
                  },
                  {
                    question: "Mikor férhetek hozzá a megtakarításomhoz?",
                    answer:
                      "A konstrukciók elsősorban a nyugdíjkorhatár elérésére vannak kialakítva; a korábbi felvétel jellemzően a kedvezmények (pl. adójóváírás) visszafizetésével vagy egyéb korlátozásokkal jár, konstrukciótól függően.",
                  },
                  {
                    question: "Mennyit érdemes havonta félretenni?",
                    answer:
                      "Ez a jövedelmedtől és a céljaidtól függ — a tanácsadás során segítünk reális, hosszú távon is fenntartható befizetési összeget meghatározni.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A fenti tartalom tájékoztató jellegű, nem minősül személyre szabott
            pénzügyi vagy adótanácsadásnak. A Financials.hu nem
            pénztárszolgáltató; a pontos feltételeket és aktuális adójogi
            szabályokat mindig a választott szolgáltató és a hatályos
            jogszabályok határozzák meg.
          </p>
        </section>
      </Container>
    </>
  );
}
